import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ProductDIYKit } from './pages/ProductDIYKit';
import { ProductCompleteKit } from './pages/ProductCompleteKit';
import { AboutPage } from './pages/AboutPage';
import { WarrantyPage } from './pages/WarrantyPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/products/forcex-diy" element={<ProductDIYKit data-id="element-5" />} data-id="element-4" />
        <Route path="/products/forcex-complete" element={<ProductCompleteKit data-id="element-7" />} data-id="element-6" />
        <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
        <Route path="/warranty" element={<WarrantyPage data-id="element-11" />} data-id="element-10" />
        <Route path="/contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
        {/* Fallback route */}
        <Route path="*" element={<HomePage data-id="element-15" />} data-id="element-14" />
      </Routes>
    </Router>;
}